import Collapse from '@rio-cloud/rio-uikit/Collapse';
import { useState } from 'react';

import type { InvoiceType } from '@/api/schema';
import Money from '@/components/Money';
import type { TimeFrame } from '@/components/TimePicker/types';
import TotalCard from '@/components/ui/TotalCard';
import { InvoicesChart } from '@/features/invoices/components/InvoicesChart';
import { InvoicesSkeleton } from '@/features/invoices/components/InvoicesSkeleton';
import { t } from '@/lib/utils';

export type InvoicesTotalProps = {
    timeFrame?: TimeFrame;
    rows?: InvoiceType[] | undefined;
    isLoading?: boolean;
    currency: string;
};

export const InvoicesTotal = ({ timeFrame, rows, isLoading, currency }: InvoicesTotalProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(true);
    let totalCosts = 0;

    rows?.forEach(s => {
        totalCosts += s?.totalCost ?? 0;
    });
    const hasData = rows && rows.length > 0;

    return (
        <div className='panel margin-top-10 display-flex width-100pct flex-column'>
            <div className={`display-flex ${isOpen && 'flex-column'}`}>
                {isLoading ? (
                    <InvoicesSkeleton />
                ) : (
                    <>
                        <div className='display-flex width-100pct flex-wrap'>
                            <div className='display-flex flex-basis-33pct' />
                            <div className='display-flex flex-basis-33pct'>
                                <TotalCard
                                    title={t('invoices.totalInvoiceAmount')}
                                    startDate={timeFrame?.startDate}
                                    endDate={timeFrame?.endDate}
                                >
                                    <span className='text-bold' style={{ lineHeight: 1, fontSize: '30px' }}>
                                        <Money currency={currency} value={totalCosts ?? 0} />
                                    </span>
                                </TotalCard>
                            </div>
                            <div className='display-flex flex-basis-33pct justify-content-end'>
                                <div className='display-flex flex-column padding-10'>
                                    <button
                                        onClick={() => setIsOpen(!isOpen)}
                                        type='button'
                                        className='btn btn-primary btn-link gap-0'
                                    >
                                        <span
                                            className={`rioglyph ${isOpen ? 'rioglyph-eye-close' : 'rioglyph-eye-open'}`}
                                            aria-hidden='true'
                                        />
                                        <span className='text-capitalize'>
                                            {isOpen
                                                ? t('invoices.button.hideOverview')
                                                : t('invoices.button.showOverview')}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        {isOpen && hasData && (
                            <Collapse open={isOpen}>
                                <div className='width-100pct margin-bottom-20'>
                                    <InvoicesChart rows={rows} currency={currency} />
                                </div>
                            </Collapse>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
